<p-dialog styleClass="preview-dialog" [style]="{minWidth: '550px'}" [closeOnEscape]="false" [closable]="false"
  header="{{dialogTitle}}" [(visible)]="displayDialog" [responsive]="true" showEffect="fade" [modal]="true"
  appendTo="body">

    <form [formGroup]="dialogForm">
      <p class="description">Please select from the dropdown the Client/Client Parent record you would like to preview:
      </p>

      <div>
        <label for="clientOrClientParent">Select Client or Client Parent</label>
      </div>
      <div>
        <p-selectButton id="clientOrClientParent" name="clientOrClientParent" [options]="clientOrClientParentOptions"
          formControlName="clientOrClientParent"></p-selectButton>
      </div>

      <div *ngIf="isClient; else clientParentTmplt">
        <p-dropdown
          hideDropdownOnScroll
          formControlName="selectedClient"
          placeholder="Select a Client"
          [filter]="true"
          filterBy="label,value.Name"
          id="clients"
          name="clients"
          [options]="clients"
          [loading]="!clients"
          appendTo="body"
          class="dropdown">
        </p-dropdown>
      </div>
      <ng-template #clientParentTmplt>
        <div>
          <p-dropdown
            hideDropdownOnScroll
            formControlName="selectedClientParent"
            placeholder="Select a Client Parent"
            [filter]="true"
            filterBy="label,value.Name"
            id="clientParents"
            name="clientParents"
            [options]="clientParents"
            [loading]="!clientParents"
            appendTo="body"
            class="dropdown"></p-dropdown>
        </div>
      </ng-template>
      <p class="note">
        Note - This will display the default dashboard only. If an individual user had changed the layout on a dashboard
        this will not be reflected here. Also any filter changes you make will not be saved.
      </p>
    </form>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <button type="button" pButton icon="fa-fw fa fa-close" (click)="cancelHandler()" label="Cancel"></button>
      <button type="button" [disabled]="!dialogForm.valid" pButton icon="fa-fw fa fa-check" (click)="okHandler()"
        label="Ok"></button>
    </div>
  </p-footer>
</p-dialog>
